module.exports = __webpack_public_path__ + "static/img/person_3.203a3fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person_3.jpg
// module id = BkXh
// module chunks = 0